/**
 * Generate all combinations of choosing k items from n items as an iterator.
 * Useful for large combination sets to avoid storing all combinations in memory.
 * @param n - total number of items.
 * @param k - number of items to choose.
 * @yields Each combination as an array of indices.
 */
export function* getCombinationsIterator(n, k) {
    if (k === 0) {
        yield [];
        return;
    }
    if (k > n)
        return;
    const current = [];
    function* backtrack(start) {
        if (current.length === k) {
            yield [...current];
            return;
        }
        for (let i = start; i < n; i++) {
            current.push(i);
            yield* backtrack(i + 1);
            current.pop();
        }
    }
    yield* backtrack(0);
}
//# sourceMappingURL=getCombinationsIterator.js.map